import { BackgroundImage } from "@mantine/core";

export async function canvasNewsPreview(imgRef: any,
    backgroundImageRef: any,) {
    var c = backgroundImageRef.current;
    var ctx = c?.getContext("2d");
    var img: any = imgRef.current;
    ctx?.drawImage(img, 0, 0, 720, 1125);
}